import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CourseIcon: FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="course icon">
      {/* <title>course icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4326 3.65385C14.495 3.65385 15.3555 4.51458 15.3555 5.57597V11.8589C14.8038 11.4015 14.0953 11.1265 13.3226 11.1265H6.39499C6.30276 11.1265 6.22945 11.0525 6.22945 10.9618V3.81863C6.22945 3.72787 6.30276 3.65385 6.39499 3.65385H13.4326ZM16.5093 14.3132V5.57597C16.5093 3.8771 15.132 2.5 13.4326 2.5H6.39499C5.66699 2.5 5.07561 3.0891 5.07561 3.81863V5.23279L4.10707 5.22137C3.37299 5.21339 2.77269 5.80638 2.77269 6.54071V16.1806C2.77269 16.9094 3.3633 17.5 4.09207 17.5H13.3226C15.0827 17.5 16.5093 16.0734 16.5093 14.3132ZM5.07561 6.38672V10.9618C5.07561 11.6913 5.66699 12.2804 6.39499 12.2804H13.3226C14.4454 12.2804 15.3555 13.1904 15.3555 14.3132C15.3555 15.4362 14.4454 16.3462 13.3226 16.3462H4.09207C4.00053 16.3462 3.92653 16.2722 3.92653 16.1806V6.54071C3.92653 6.44884 4.00169 6.37428 4.09376 6.37514C4.09384 6.37514 4.09369 6.37514 4.09376 6.37514L5.07561 6.38672ZM13.6475 14.324C13.6475 14.0054 13.3892 13.7471 13.0705 13.7471H5.79792C5.4793 13.7471 5.22099 14.0054 5.22099 14.324C5.22099 14.6426 5.4793 14.9009 5.79792 14.9009H13.0705C13.3892 14.9009 13.6475 14.6426 13.6475 14.324Z"
        fill={props.fill || "currentColor" || "#202123"}
      />
    </svg>
  );
};

export default CourseIcon;
